<template>
  <div id="LayerOut">
    <div id="droppalbe" class="bg ui-droppable">
      <div id="LayerBill">
        <div v-for="(cache, index) of cachetDate" :key="index">
          <div class="cacheImg" :style="{ top: cache.y, left: cache.x }">
            <img :src="cache.imgUrl" />
          </div>
        </div>
        <table width="700" border="0" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td>
                <table width="650" border="0" align="center" cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr>
                      <td height="25" colspan="3" align="center">&nbsp;</td>
                    </tr>
                    <tr>
                      <td height="25" colspan="3" align="center" style="font-size: 24px; font-weight: bold">
                        销售合同
                      </td>
                    </tr>
                    <tr>
                      <td height="25" colspan="3">&nbsp;</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;&nbsp;</td>
                      <td height="25" colspan="2">
                        甲方：
                        <input
                          :value="aBill.a1"
                          name="A[0].a1"
                          cname="a1"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                        乙方：
                        <input
                          :value="aBill.a2"
                          name="A[0].a2"
                          cname="a2"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td width="41" height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        地址：
                        <input
                          :value="aBill.a3"
                          name="A[0].a3"
                          cname="a3"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                        地址：
                        <input
                          :value="aBill.a4"
                          name="A[0].a4"
                          cname="a4"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        电话：
                        <input
                          :value="aBill.a5"
                          name="A[0].a5"
                          cname="a5"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                        电话：
                        <input
                          :value="aBill.a6"
                          name="A[0].a6"
                          cname="a6"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        传真：
                        <input
                          :value="aBill.a7"
                          name="A[0].a7"
                          cname="a7"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                        传真：
                        <input
                          :value="aBill.a8"
                          name="A[0].a8"
                          cname="a8"
                          type="text"
                          style="width: 250px; border-bottom: 1px solid #000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        甲、乙双方友好协议，与自愿、平等互利为原则，根据《中华人民共和国合同法》，双方达成如下协议：
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">一、甲、乙双方的权利和义务</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        1、甲方是
                        <input
                          :value="aBill.a9"
                          name="A[0].a9"
                          cname="a9"
                          type="text"
                          style="width: 100px; border-bottom: 1px solid #000"
                        />
                        产品的供应商，乙方是经销商。
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        2、乙方作为甲方的经销商，应尽经销商的责任。在上述区域应按甲方销售策略销售要求，尽最大努力将
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">甲方产品销售。甲方也应保证供应足够的货源。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">3、产品的型号由订单、收货单确定，最终以收货单为准。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">4、运输及运费计算：运费由乙方承担并支付相应的费用。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        5、付款期限：甲方对乙方的付款条件为
                        <input
                          :value="aBill.a10"
                          name="A[0].a10"
                          cname="a10"
                          type="text"
                          style="width: 100px; border-bottom: 1px solid #000"
                        />
                        ，即甲方发货后30天内，乙方必须付款。
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2"></td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        <p align="left">二、产品销售数量及订单</p>
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        <table width="601" border="0" cellpadding="0" cellspacing="0" class="billtable">
                          <tbody>
                            <tr>
                              <td height="25" width="172" align="center">产品名称</td>
                              <td width="118" align="center">订单号</td>
                              <td width="100" align="center">单&nbsp;价（含税）</td>
                              <td width="100" align="center">数&nbsp;&nbsp;量</td>
                              <td width="100" align="center">金&nbsp;&nbsp;额</td>
                            </tr>
                            <tr v-for="(tableCells, index2) in bDataList" :key="index2">
                              <td
                                v-for="(cell, index3) in tableCells.data"
                                :key="index3"
                                :style="{ width: index3 === 1 ? '118px' : '100px' }"
                              >
                                <input
                                  :value="cell"
                                  type="text"
                                  style="width: 172px"
                                  :style="{ width: index3 === 1 ? '118px' : '100px' }"
                                />
                              </td>
                            </tr>

                            <tr>
                              <td height="25" align="center">总&nbsp;&nbsp;计</td>
                              <td>
                                <input
                                  :value="aBill.a11"
                                  name="A[0].a11"
                                  cname="a11"
                                  type="text"
                                  style="width: 118px; font-size: 14px"
                                />
                              </td>
                              <td>
                                <input
                                  :value="aBill.a12"
                                  name="A[0].a12"
                                  cname="a12"
                                  type="text"
                                  style="width: 100px; text-align: right; font-size: 14px"
                                  class="isNumeric"
                                />
                              </td>
                              <td>
                                <input
                                  :value="aBill.a13"
                                  name="A[0].a13"
                                  cname="a13"
                                  type="text"
                                  style="width: 100px; text-align: right; font-size: 14px"
                                  class="isNumeric"
                                />
                              </td>
                              <td>
                                <input
                                  :value="aBill.a14"
                                  name="A[0].a14"
                                  cname="a14"
                                  type="text"
                                  style="width: 100px; text-align: right; font-size: 14px"
                                  class="isNumeric"
                                />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">三、产品结算方式</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">1、一次付款</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">2、付款方式为转账</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        甲方开户名称：
                        <input :value="aBill.a15" name="A[0].a15" cname="a15" type="text" style="width: 300px" />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        账号：
                        <input
                          :value="aBill.a16"
                          name="A[0].a16"
                          cname="a16"
                          type="text"
                          style="width: 300px"
                          class="isNumeric"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        开户行：
                        <input :value="aBill.a17" name="A[0].a17" cname="a17" type="text" style="width: 300px" />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">四、合同的变更及终止</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">1、经友好协商，甲、乙双方可以变更合同。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        2、本协议期满后，由甲、乙双方协商是否续签本协议，乙方具有优先续签本协议的权利。
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">五、违约责任：</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        1、对于乙方的以下行为，甲方可随时中止或终止本协议，追究乙方的违约责任，违约金为合同金额的
                        <input
                          :value="aBill.a18"
                          name="A[0].a18"
                          cname="a18"
                          type="text"
                          style="width: 30px; border-bottom: 1px solid #000"
                        />
                        。
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">(1)乙方违反了结算规定，未按要求付货款；</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        (2)乙方经营遇到巨大困难或管理发生实质性变化，如由他人承包、可能破产，导致甲方的权利无法得到
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">保障时。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        2 、本协议发生争议，双方以友好协商的方式解决，协商不成时，可申请仲裁或由甲方所在地人民法院管
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">辖，依法处理。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">六、附则</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">
                        1、本协议有效期为：
                        <input
                          :value="aBill.a19"
                          name="A[0].a19"
                          cname="a19"
                          type="text"
                          style="width: 35px; border-bottom: 1px solid #000"
                          class="isNumeric"
                        />
                        年
                        <input
                          :value="aBill.a20"
                          name="A[0].a20"
                          cname="a20"
                          type="text"
                          style="width: 25px; border-bottom: 1px solid #000"
                          class="isNumeric"
                        />
                        月
                        <input
                          :value="aBill.a21"
                          name="A[0].a21"
                          cname="a21"
                          type="text"
                          style="width: 25px; border-bottom: 1px solid #000"
                          class="isNumeric"
                        />
                        日至
                        <input
                          :value="aBill.a91"
                          name="A[0].a91"
                          cname="a91"
                          type="text"
                          style="width: 35px; border-bottom: 1px solid #000"
                          class="isNumeric"
                        />
                        年
                        <input
                          :value="aBill.a92"
                          name="A[0].a92"
                          cname="a92"
                          type="text"
                          style="width: 25px; border-bottom: 1px solid #000"
                          class="isNumeric"
                        />
                        月
                        <input
                          :value="aBill.a93"
                          name="A[0].a93"
                          cname="a93"
                          type="text"
                          style="width: 25px; border-bottom: 1px solid #000"
                          class="isNumeric"
                        />
                        日。
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">2、其它未尽事宜双方可友好协商。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">3、本协议一式两份，双方各执一份，签名盖章后即生效。</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25" colspan="2">&nbsp;</td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td width="259" height="25">
                        甲方：
                        <u>&nbsp;&nbsp;&nbsp;&nbsp;（盖章）&nbsp;&nbsp;&nbsp;&nbsp;</u>
                      </td>
                      <td width="350">
                        乙方：
                        <u>&nbsp;&nbsp;&nbsp;&nbsp;（盖章）&nbsp;&nbsp;&nbsp;&nbsp;</u>
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25">
                        法人代表：
                        <input
                          :value="aBill.a22"
                          name="A[0].a22"
                          cname="a22"
                          type="text"
                          style="width: 180px; border-bottom: 1px solid #000"
                        />
                      </td>
                      <td height="25">
                        法人代表：
                        <input
                          :value="aBill.a23"
                          name="A[0].a23"
                          cname="a23"
                          type="text"
                          style="width: 180px; border-bottom: 1px solid #000"
                        />
                      </td>
                    </tr>
                    <tr>
                      <td height="25">&nbsp;</td>
                      <td height="25">
                        签约日期：
                        <input
                          :value="aBill.a24"
                          name="A[0].a24"
                          cname="a24"
                          type="text"
                          style="width: 180px; border-bottom: 1px solid #000"
                        />
                      </td>
                      <td height="25">
                        签约日期：
                        <input
                          :value="aBill.a25"
                          name="A[0].a25"
                          cname="a25"
                          type="text"
                          style="width: 180px; border-bottom: 1px solid #000"
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <br />
  </div>
</template>

<script>
import { environment } from '@/utils/oss.env'
export default {
  props: {
    bgDatas: { type: Array, default: () => [] },
  },
  data() {
    return {
      aBill: [],
      cachetDate: [],
      bDataList: [],
    }
  },
  mounted() {
    this.initABData()
  },
  methods: {
    initABData() {
      let bData = {}
      const cacheList = []
      const bDataList = []
      for (const index in this.bgDatas) {
        if (this.bgDatas[index]['a'] !== undefined) {
          bData = {}
          this.aBill = this.bgDatas[index]['a']
        } else if (this.bgDatas[index]['c'] !== undefined) {
          const cl = this.bgDatas[index]['c']
          for (const jIndex in cl) {
            const c = cl[jIndex]
            bData = {}
            const t = { imgUrl: '', x: '', y: '' }
            t.imgUrl = environment.cacheUrl + c.imgUrl
            t.x = c.x + 'px'
            t.y = c.y + 'px'
            cacheList.push(t)
          }
        } else if (this.bgDatas[index]['b'] !== undefined) {
          const bl = this.bgDatas[index]['b']
          for (const jIndex in bl) {
            const b = bl[jIndex]
            bData = {}
            const t = []
            t.push(b.b1)
            t.push(b.b2)
            t.push(b.b3)
            t.push(b.b4)
            t.push(b.b5)
            bData['data'] = t
            bDataList.push(bData)
          }
        }
      }
      this.bDataList = bDataList
      this.cachetDate = cacheList
    },
  },
}
</script>

<style lang="less" scoped>
#LayerBill {
  margin-top: 20px;
  padding-left: 0;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 700px;
  height: 1400px;
}

#paperBg {
  position: absolute;
  top: 0;
  left: -1px;
  z-index: 1;
  width: 700px;
  height: 700px;
}

TABLE.outtable {
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
}

TABLE.thickbordertable {
  border: 1px solid #000000;
}

TABLE.billtable {
  width: 100%;
  font-family: Tahoma;
  font-size: 12px;
  color: #000000;
  white-space: nowrap;
  border-top: 1px solid #000000;
  border-left: 0px;
  border-right: 1px solid #000000;
  border-bottom: 0px;
}

.billtable TD {
  border-top: 0px;
  border-left: 1px solid #000000;
  border-right: 0px;
  border-bottom: 1px solid #000000;
}

INPUT {
  font-family: '楷体_GB2312', '楷体';
  font-size: 12px;
  font-weight: bold;
  background-color: transparent;
  background: none;
  letter-spacing: 0px;
  word-spacing: normal;
  border: 1px none #cccccc;
  overflow: hidden;
  width: 100%;
  line-height: 18px;
  color: black;
}

.cacheImg {
  position: absolute;
  z-index: 1000;
}
a {
  color: #333;
  text-decoration: none;
}

a:hover {
  color: #f30;
}

.pl10 {
  padding-left: 10px;
}

.pr10 {
  padding-right: 10px;
}

.drag {
  position: relative;
  cursor: pointer;
}

#bgDiv .tn-tools {
  padding-top: 3px;
  line-height: 35px;
  height: 35px;
  border-bottom: 1px solid #f06000;
}

#bgDiv .tn-tools ul {
  zoom: 1;
  height: 30px;
  position: relative;
  font-size: 14px;
  list-style: none;
  margin: 0;
  padding: 0;
}

#bgDiv .tn-tools li {
  float: left;
  text-align: left;
  line-height: 30px;
  list-style: none;
}

#bgDiv .tn-tools .w4 {
  width: 105px;
  text-align: right;
  float: right;
}

#bgDiv .tn-tools a {
  padding: 0 20px;
  float: left;
  line-height: 30px;
  font-size: 14px;
  margin: 0px 0px 0 5px;
  position: relative;
  background: #d1d4d3;
}

#bgDiv .tn-tools a:hover {
  background: #f06000;
  color: #fff;
  border-radius: 2px;
}

#bgDiv .tn-pop {
  position: absolute;
  right: 5px;
  background: #ffffff;
  color: #fff;
  clear: both;
  font-size: 14px;
  z-index: 999;
  top: 33px;
  display: none;
  margin: 0;
  padding: 0;
}

#bgDiv .menu-pop {
  background-color: #fafafa;
  border: #f06000 solid 2px;
  border-top: none;
  position: relative;
  -webkit-box-shadow: 2px 3px 3px #dfdfdf;
  -moz-box-shadow: 2px 3px 3px #dfdfdf;
  box-shadow: 2px 3px 0px #ededed;
  float: left;
  width: 120px;
  overflow-y: auto;
  overflow-x: hidden;
  font-family: '\5b8b\4f53';
  z-index: 1999;
  margin: 0;
  padding: 0;
  top: 5px;
}

#bgDiv .menu-pop ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

#bgDiv .menu-pop li {
  width: 100%;
  float: left;
  border-bottom: #f0f0f0 solid 1px;
  display: inline;
}

#bgDiv .menu-pop li:hover {
  background-color: #f3f3f3;
}

#bgDiv .menu-pop a {
  padding: 7px 8px;
  display: block;
  text-align: left;
  line-height: 30px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
}

#bgDiv.menu-pop a:hover {
  color: #f06000;
}
#LayerOut {
  position: relative;
  top: 0;
  left: 0;
  z-index: 0;
  width: 700px;
  height: 1500px;
}

.bg {
  background: url(~@/assets/odco_dzcpxshtfb.png);
  position: relative;
  z-index: 1;
  width: 700px;
  height: 1450px;
  top: 0px;
  left: 0px;
  clear: both;
}
input.isNumeric {
  font-family: 'å®‹ä½“';
  font-size: 12px;
  font-style: oblique;
  line-height: 18px;
  height: 18px;
}
</style>
